"use client";

import { useEffect } from "react";
import Button from "@/components/common/PrimaryButton";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const handleRefresh = () => {
    window.location.reload();
  };

  useEffect(() => {
    try {
      const errorDetails = {
        message: error.message || "Unknown error",
        stack: error.stack || "No stack trace available",
        userAgent: navigator.userAgent || "Unknown",
        url: window.location.href || "Unknown URL",
        timestamp: new Date().toISOString(),
      };

      const reqBody = {
        content: JSON.stringify(errorDetails, null, 2),
      };

      const webhookUrl = process.env.NEXT_PUBLIC_DISCORD_WEBHOOK_URL;

      if (webhookUrl) {
        fetch(webhookUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqBody),
        })
          .then((response) => {
            if (!response.ok) {
              console.warn(
                `Error report failed with status: ${response.status}`
              );
            }
          })
          .catch((err) => {
            console.warn("Failed to send error report:", err.message);
          });
      }
    } catch (e) {
      console.warn("Error in error reporting:", e);
    }
  }, [error]);

  return (
    <html>
      <body>
        <div
          style={{
            paddingTop: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 20,
            height: "100svh",
            width: "100vw",
            color: "#000000",
            background: "#ffffff",
          }}
        >
          <h1>Something went wrong!</h1>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Button variant="outlined" onClick={() => handleRefresh()}>
              Try again
            </Button>
            <a
              href={`${process.env.NEXT_PUBLIC_BASE_URL || "/"}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Button color="secondary">Go Home</Button>
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
